<template>
  <div>
    <v-row class="mb-5 cols-12">
      <v-col cols="6">
        <span> Add new option </span>
        <v-icon size="40" @click="addOption()">mdi-plus</v-icon>
      </v-col>
    </v-row>

    <v-col cols="12" v-for="(option, idx) in question.questionOptions" :key="idx" class="px-0">
      <v-card tile outlined>
        <v-card-text>
          <v-row>
            <v-col cols="6">
              <v-text-field dense outlined label="Option Text" @blur="ctrl.update(question)" placeholder="Option Text"
                v-model="option.optionContent[0].optionText" clearable>
              </v-text-field>
              <v-text-field dense outlined label="Option Help" @blur="ctrl.update(question)" placeholder="Option Help"
                v-model="option.optionContent[0].optionHelp" clearable>
              </v-text-field>
            </v-col>
            <v-col cols="5">
              <v-text-field dense outlined label="option Value" @blur="ctrl.update(question)" placeholder="Option Text"
                v-model="option.answerText" clearable>
              </v-text-field>
            </v-col>
            <v-col cols="1">
              <v-btn icon>
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </div>
</template>

<script>
  export default {
    name: "multiple",
    props: {
      question: Object,
      updateQuestion: Function
    },
    data() {
      return {
        ctrl: this.get_controller("questionnaire_question"),
        types: [{
            text: "Number",
            value: "answerNumeric",
          },
          {
            text: "bool",
            value: "answerBool",
          },
          {
            text: "text",
            value: "answerText",
          },
        ],
      };
    },
    methods: {
      addOption() {
        let self = this;
        let newOption = {
          id: 0,
          questionnaireQuestionId: self.question.id,
          answerNumeric: 0,
          answerText: "",
          answerBool: null,
          optionContent: [{
            id: 0,
            languageId: 0,
            questionnaireQuestionOptionId: 0,
            optionText: "",
            optionHelp: "",
          }],
        };

        self.question.questionOptions.push(newOption);

        this.ctrl.update(self.question);
      },
      removeOption() {

      }
    },
  };
</script>